import React from "react";
import "../styles/Portfolio.css";

const Portfolio = () => {
  const projects = [
    {
      title: "Project 1",
      image: "project1.jpg",
      description: "A brief description of Project 1.",
    },
    {
      title: "Project 2",
      image: "project2.jpg",
      description: "A brief description of Project 2.",
    },
    {
      title: "Project 3",
      image: "project3.jpg",
      description: "A brief description of Project 3.",
    },
  ];

  return (
    <section id="portfolio" className="portfolio">
      <h2>Portfolio</h2>
      <div className="portfolio-list">
        {projects.map((project, index) => (
          <div key={index} className="portfolio-item">
            <img src={`/assets/images/${project.image}`} alt={project.title} />
            <h3>{project.title}</h3>
            <p>{project.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
